import { Component, OnInit } from '@angular/core';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';
import { KitchenStockConsumptionService } from '../../shared/services/kitchen-stock-consumption.service';

@Component({
  selector: 'ngx-consumption-report',
  templateUrl: './consumption-report.component.html',
  styleUrls: ['./consumption-report.component.scss']
})
export class ConsumptionReportComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  fromDate : string;
  toDate : string;
  isDark: boolean = false;

  dataList : any[]=[];
  filteredDataList : any[]=[];



  constructor(
              private kitchenStockConsumptionService : KitchenStockConsumptionService, 
              private router : Router, 
              private themeService: NbThemeService,
              private decimalPipe : DecimalPipe
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });
    }

 
    getAll(startDate, endDate) {
    this.kitchenStockConsumptionService.getReport(startDate ,endDate)
     .subscribe(
        (data) => {
                  this.dataList = data;                        
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getTotal(){
      return this.dataList.map(totalBal=>totalBal.Amount).reduce((acc,value)=>acc + +value,0);
    }
    

      viewBtnClicked(){
        if(this.fromDate && this.toDate){
            var startDate =moment(this.fromDate).format("YYYY-MM-DD");
            var endDate =moment(this.toDate).format("YYYY-MM-DD");
            this.getAll(startDate, endDate)
        }


      }


     clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
     this.dataList = [];
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'portrait',

        content: [   
          { text: 'Kitchen Stock Consumption Report', style: 'reportHeader' }, 
          { text: (this.fromDate && this.toDate) ? `${moment(this.fromDate).format("YYYY-MM-DD")} To ${moment(this.toDate).format("YYYY-MM-DD")}` : '',alignment: 'center',margin: [0,5,0,5] }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['*', 'auto', 'auto','auto',  'auto', 'auto'],  
                body: [  
                  ['Item', 'Qty','Unit Price',  'Amount', 'Created At', 'Created By'],
                  ...this.dataList.map(p => ([p.Name,p.qty, {text : this.transformNumberFormat(p.UnitCost), alignment: 'right'  }, {text : this.transformNumberFormat(p.Amount), alignment: 'right'  },moment(p.created_at).format("YYYY-MM-DD"), p.created_by])),  
                  [ { text: 'Total Cost of Consumption', bold: true, colSpan: 3 }, {},{}, { text :  this.transformNumberFormat(this.getTotal()),alignment: 'right', bold : true },{},{} ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 10],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('expReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Consumption Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
   }


}
